import { useMemo } from 'react';

import { renderCharacterLimitEndAdornment } from '../../renderers';
import { InputProps } from '../../types';

interface Params
  extends Pick<InputProps, 'characterLimit' | 'endAdornment' | 'inputProps' | 'value' | 'variant'> {
  endAdornmentClassName?: string;
}

const useCharacterLimit = (params: Params): Pick<InputProps, 'endAdornment' | 'inputProps'> => {
  const {
    characterLimit,
    endAdornment: endAdornmentProp,
    endAdornmentClassName: className,
    inputProps: inputPropsProp,
    value,
    variant,
  } = params;

  const endAdornment = useMemo(() => {
    if (!characterLimit) {
      return endAdornmentProp;
    }

    return renderCharacterLimitEndAdornment({ characterLimit, className, value, variant });
  }, [characterLimit, className, endAdornmentProp, value, variant]);

  const inputProps = useMemo(
    () => (characterLimit ? { maxLength: characterLimit, ...inputPropsProp } : inputPropsProp),
    [characterLimit, inputPropsProp],
  );

  return { endAdornment, inputProps };
};

export default useCharacterLimit;
